import { type MoveEvent, TYPE_MASK, WHITE, baseType, isWounded, pieceColor, pieceDef } from '@chessbut/engine';
import type { VariantUi } from './ui.ts';

const HEARTS = '/art/hearts.svg';
const wound = (e: MoveEvent) => e.t === 'add' && e.cause === 'wound';

export const hpUi: VariantUi = {
  heroImage: HEARTS,
  peek: [{}, { image: '/art/bR-hurt.svg', threat: true }, {}, {}, {}, {}, {}, { image: '/art/wR.svg' }, {}],

  pieceImage(_pos, _sq, piece) {
    if (!isWounded(piece)) return null;
    const letter = pieceDef(baseType(piece & TYPE_MASK)).letter.toUpperCase();
    return `/art/${pieceColor(piece) === WHITE ? 'w' : 'b'}${letter}-hurt.svg`;
  },

  twist(pos, you) {
    const me = you ?? pos.turn;
    let hurt = 0;
    for (const p of pos.board) if (isWounded(p) && pieceColor(p) === me) hurt++;
    if (hurt) {
      const whose = you === null ? (me === WHITE ? 'White' : 'Black') : 'You';
      return { text: `${whose} ${you === null ? 'has' : 'have'} ${hurt} wounded ${hurt === 1 ? 'piece' : 'pieces'}: one more hit takes ${hurt === 1 ? 'it' : 'them'}` };
    }
    return { text: 'Every piece has 2 HP: the first capture only wounds' };
  },

  eventSound(e) {
    return e.t === 'fx' && e.kind === 'hit' ? 'hit' : null;
  },

  moveBadge(rec) {
    const e = rec.events.find(wound);
    return e && e.t === 'add' ? { icon: HEARTS, victim: e.piece, title: `Wounded a ${pieceDef(baseType(e.piece & TYPE_MASK)).name}` } : null;
  },
};
